import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Button } from '../components/ui/button';
import { PayerList } from '../components/PayerList';
import { Plus } from 'lucide-react';

export const PayersPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto p-6">
      <div className="flex items-center gap-4 mb-6">
        <Link to="/">
          <Button variant="outline" size="sm">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>
        <h1 className="text-3xl font-bold">Payers Management</h1>
      </div>

      <div className="flex justify-end mb-4">
        <Link to="/payers/create">
          <Button>
            <Plus className="h-4 w-4 mr-2" />
            Create Payer
          </Button>
        </Link>
      </div>

      <PayerList />
    </div>
  );
};
